import { render, staticRenderFns } from "./WabaSupsisMmLiteTermsSigned.vue?vue&type=template&id=d81642b4&scoped=true"
import script from "./WabaSupsisMmLiteTermsSigned.vue?vue&type=script&lang=js"
export * from "./WabaSupsisMmLiteTermsSigned.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisMmLiteTermsSigned.vue?vue&type=style&index=0&id=d81642b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81642b4",
  null
  
)

export default component.exports